/*!
 * Happy Punch — Eigen Foto Dot Painting configurator
 * Flow: knop → foto kiezen → ① Formaat (uitsnede + live preview) → ② Afwerking → /cart/add.js met de foto als bestand → UpCart
 * Shopify slaat de foto zelf op en zet de link bij de bestelregel (max. 20 MB per bestand).
 * Meertalig: teksten komen uit #hpdc-strings (snippet), prijzen in de valuta van de bezoeker.
 */
(function () {
  "use strict";

  var root = document.getElementById("hpdc-root");
  if (!root) return;

  /* ---------------------------------------------------------------- Config */
  var CFG = {
    photoProp: root.dataset.photoProperty || "Foto",
    uploadOriginal: root.dataset.uploadOriginal === "true",
    buttonText: root.dataset.buttonText || "Upload hier jouw foto",
    maxBytes: 25 * 1024 * 1024,
    lang: (root.dataset.lang || "nl").toLowerCase(),
    intl: root.dataset.intlLocale || "nl-NL",
    currency: root.dataset.currency || "EUR",
    popular: root.dataset.popularSize || "",
    best: root.dataset.bestSize || ""
  };
  var PRODUCT = JSON.parse(document.getElementById("hpdc-product").textContent);
  function readJSON(id) { try { return JSON.parse((document.getElementById(id) || {}).textContent || "{}"); } catch (e) { return {}; } }

  /* Teksten: gekozen taal, met Nederlands als terugval voor ontbrekende teksten */
  var STRINGS = readJSON("hpdc-strings"), T = {}, k;
  for (k in (STRINGS.nl || {})) T[k] = STRINGS.nl[k];
  for (k in (STRINGS[CFG.lang] || {})) T[k] = STRINGS[CFG.lang][k];
  function t(key, vars) {
    var s = T[key] == null ? key : String(T[key]);
    if (vars) for (var v in vars) s = s.split("{" + v + "}").join(vars[v]);
    return s;
  }
  var ADVICE_ALL = readJSON("hpdc-advice");
  var ADVICE = ADVICE_ALL[CFG.lang] || ADVICE_ALL.nl || ADVICE_ALL; // ook het oude, platte formaat werkt nog
  var ROUTES = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* Welke optie is het formaat en welke het frame? Herkend aan "30x40" in de waarden. */
  var optCount = (PRODUCT.options || []).length || 2;
  var sizeIdx = 1, frameIdx = 2;
  for (var i = 1; i <= Math.min(optCount, 3); i++) {
    if (PRODUCT.variants.some(function (v) { return /\d+\s*x\s*\d+/i.test(v["option" + i] || ""); })) { sizeIdx = i; break; }
  }
  frameIdx = sizeIdx === 1 ? 2 : 1;

  var SIZES = [];
  PRODUCT.variants.forEach(function (v) {
    var opt = v["option" + sizeIdx];
    if (SIZES.some(function (s) { return s.option === opt; })) return;
    var m = opt.match(/(\d+)\s*x\s*(\d+)\s*cm\s*(?:\((.+)\))?/i);
    if (!m) return;
    SIZES.push({ option: opt, w: +m[1], h: +m[2], tag: m[3] || "", key: m[1] + "x" + m[2] });
  });
  var FRAMES = [];
  PRODUCT.variants.forEach(function (v) { var f = v["option" + frameIdx]; if (f && FRAMES.indexOf(f) < 0) FRAMES.push(f); });
  if (!FRAMES.length) FRAMES = [null];
  /* Met of zonder frame? Herkend aan de volgorde, niet aan de naam (die is per taal anders):
     de eerste waarde van de frame-optie is "zonder frame", elke volgende waarde is "met frame". */
  function isFramed(f) { return f != null && FRAMES.indexOf(f) > 0; }

  function findVariant(sizeOpt, frameOpt) {
    return PRODUCT.variants.find(function (v) {
      return v["option" + sizeIdx] === sizeOpt && (frameOpt === null || v["option" + frameIdx] === frameOpt);
    });
  }
  function fromPrice(sizeOpt) {
    return Math.min.apply(null, PRODUCT.variants.filter(function (v) { return v["option" + sizeIdx] === sizeOpt; }).map(function (v) { return v.price; }));
  }
  /* Prijzen in de valuta van de bezoeker: €30,00 voor NL/BE, £30.00 voor de UK */
  var MONEY = null, NUM = null;
  try { MONEY = new Intl.NumberFormat(CFG.intl, { style: "currency", currency: CFG.currency }); } catch (e) {}
  try { NUM = new Intl.NumberFormat(CFG.intl); } catch (e) { NUM = new Intl.NumberFormat("nl-NL"); }
  function money(c) {
    if (!MONEY) return CFG.currency + " " + (c / 100).toFixed(2);
    return MONEY.format(c / 100).replace(/^([^\d\s-]+)\s/, "$1"); // "€ 30,00" → "€30,00"
  }
  var nl = new Intl.NumberFormat("nl-NL"); // alleen voor de verborgen ordergegevens (fulfilment)

  /* ------------------------------------------------------------ Dot-engine */
  var DotEngine = (function () {
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
    var DOT = { pitchX: 0.40, pitchY: 0.32, maxR: 0.185, minFrac: 0.15 }; // cm; minFrac = kleinste stip t.o.v. de grootste
    function region(src, r, w, h) {
      var c = document.createElement("canvas"); c.width = w; c.height = h;
      var ctx = c.getContext("2d", { willReadFrequently: true });
      ctx.imageSmoothingQuality = "high";
      var midW = Math.min(Math.round(r.w), w * 3), midH = Math.min(Math.round(r.h), h * 3);
      if (midW > w * 1.5) {
        var m = document.createElement("canvas"); m.width = midW; m.height = midH;
        var mc = m.getContext("2d"); mc.imageSmoothingQuality = "high";
        mc.drawImage(src, r.x, r.y, r.w, r.h, 0, 0, midW, midH);
        ctx.drawImage(m, 0, 0, w, h);
      } else ctx.drawImage(src, r.x, r.y, r.w, r.h, 0, 0, w, h);
      return ctx.getImageData(0, 0, w, h);
    }
    function tone(img) {
      var n = img.width * img.height, d = img.data, L = new Float32Array(n), hist = new Uint32Array(256), i, v, a;
      for (i = 0; i < n; i++) { var l = .2126 * d[i * 4] + .7152 * d[i * 4 + 1] + .0722 * d[i * 4 + 2]; L[i] = l; hist[l | 0]++; }
      var lo = 0, hi = 255;
      for (v = 0, a = 0; v < 256; v++) { a += hist[v]; if (a > n * .01) { lo = v; break; } }
      for (v = 255, a = 0; v >= 0; v--) { a += hist[v]; if (a > n * .01) { hi = v; break; } }
      if (hi - lo < 20) { lo = 0; hi = 255; }
      for (i = 0; i < n; i++) L[i] = clamp((L[i] - lo) / (hi - lo), 0, 1);
      return L;
    }
    function sample(L, w, h, fx, fy) {
      var x = clamp(fx * w - .5, 0, w - 1), y = clamp(fy * h - .5, 0, h - 1);
      var x0 = x | 0, y0 = y | 0, x1 = Math.min(x0 + 1, w - 1), y1 = Math.min(y0 + 1, h - 1), tx = x - x0, ty = y - y0;
      return (L[y0 * w + x0] * (1 - tx) + L[y0 * w + x1] * tx) * (1 - ty) + (L[y1 * w + x0] * (1 - tx) + L[y1 * w + x1] * tx) * ty;
    }
    function render(src, rect, wCm, hCm, pxPerCm, out) {
      var mw = Math.ceil(wCm * 5), mh = Math.ceil(hCm * 5);
      var L = tone(region(src, rect, mw, mh));
      out.width = Math.round(wCm * pxPerCm); out.height = Math.round(hCm * pxPerCm);
      var ctx = out.getContext("2d");
      ctx.fillStyle = "#FCFCFA"; ctx.fillRect(0, 0, out.width, out.height);
      var rows = Math.floor(hCm / DOT.pitchY), cols = Math.floor(wCm / DOT.pitchX), offY = (hCm - rows * DOT.pitchY) / 2;
      var p = new Path2D(), count = 0;
      for (var r = 0; r < rows; r++) {
        var y = offY + (r + .5) * DOT.pitchY, sh = (r % 2) ? DOT.pitchX / 2 : 0;
        for (var c = 0; c < cols; c++) {
          var x = (c + .5) * DOT.pitchX + sh;
          if (x > wCm - DOT.pitchX * .3) continue;
          var dark = Math.pow(1 - sample(L, mw, mh, x / wCm, y / hCm), 1.08);
          // elke plek krijgt minimaal een klein stipje (15% van de grootste), zodat lichte delen niet leeg blijven
          var m2 = DOT.minFrac * DOT.minFrac;
          var rad = DOT.maxR * Math.sqrt(m2 + (1 - m2) * dark) * pxPerCm;
          p.moveTo(x * pxPerCm + rad, y * pxPerCm); p.arc(x * pxPerCm, y * pxPerCm, rad, 0, Math.PI * 2); count++;
        }
      }
      ctx.fillStyle = "#141414"; ctx.fill(p);
      return count;
    }
    return { render: render };
  })();

  /* ------------------------------------------------------------ Mockup: op frame gespannen of los canvas */
  function mockup(src, framed) {
    var w = src.width, h = src.height, c = document.createElement("canvas"), x = c.getContext("2d");
    if (framed) {
      var d = Math.round(Math.min(w, h) * 0.07), k = 0.38, pad = Math.round(Math.min(w, h) * 0.07);
      c.width = w + d + pad * 2; c.height = h + Math.round(d * k) + pad * 2;
      // schaduw onder het frame
      x.save(); x.shadowColor = "rgba(20,30,35,.32)"; x.shadowBlur = pad * 0.9; x.shadowOffsetX = d * 0.5; x.shadowOffsetY = d * 0.9;
      x.fillStyle = "#fff"; x.beginPath();
      x.moveTo(pad, pad); x.lineTo(pad + w, pad); x.lineTo(pad + w + d, pad + d * k); x.lineTo(pad + w + d, pad + h + d * k);
      x.lineTo(pad + d, pad + h + d * k); x.lineTo(pad, pad + h); x.closePath(); x.fill(); x.restore();
      // zijkant rechts: het canvas loopt om het frame heen
      x.save(); x.setTransform(1, k, 0, 1, pad + w, pad);
      var g = x.createLinearGradient(0, 0, d, 0); g.addColorStop(0, "#E9E9E5"); g.addColorStop(1, "#D2D2CD");
      x.fillStyle = g; x.fillRect(0, 0, d, h); x.restore();
      // onderkant
      x.save(); x.setTransform(1, 0, 1 / k, 1, pad, pad + h);
      x.fillStyle = "#DEDED9"; x.fillRect(0, 0, w, d * k); x.restore();
      // voorkant met lichte glans op de bovenrand
      x.drawImage(src, pad, pad);
      var hl = x.createLinearGradient(0, pad, 0, pad + h * 0.25); hl.addColorStop(0, "rgba(255,255,255,.18)"); hl.addColorStop(1, "rgba(255,255,255,0)");
      x.fillStyle = hl; x.fillRect(pad, pad, w, h * 0.25);
      x.strokeStyle = "rgba(0,0,0,.08)"; x.lineWidth = 1; x.strokeRect(pad + .5, pad + .5, w - 1, h - 1);
    } else {
      var m = Math.round(Math.min(w, h) * 0.07), SW = w + 2 * m, SH = h + 2 * m, cr = Math.round(Math.min(SW, SH) * 0.14), pd = Math.round(Math.min(w, h) * 0.05);
      c.width = SW + pd * 2; c.height = SH + pd * 2;
      x.translate(pd, pd);
      function sheet() { x.beginPath(); x.moveTo(0, 0); x.lineTo(SW, 0); x.lineTo(SW, SH - cr); x.lineTo(SW - cr, SH); x.lineTo(0, SH); x.closePath(); }
      // vel canvas met zachte schaduw
      x.save(); x.shadowColor = "rgba(20,30,35,.22)"; x.shadowBlur = pd * 0.8; x.shadowOffsetY = pd * 0.25;
      x.fillStyle = "#FBFBF9"; sheet(); x.fill(); x.restore();
      // print met witte rand, afgesneden bij de omgekrulde hoek
      x.save(); sheet(); x.clip(); x.drawImage(src, m, m); x.restore();
      // omgekrulde hoek
      x.save(); x.shadowColor = "rgba(0,0,0,.25)"; x.shadowBlur = cr * 0.25; x.shadowOffsetX = -cr * 0.08; x.shadowOffsetY = -cr * 0.08;
      var fg = x.createLinearGradient(SW - cr, SH - cr, SW - cr * 0.5, SH - cr * 0.5);
      fg.addColorStop(0, "#FFFFFF"); fg.addColorStop(0.7, "#ECECEA"); fg.addColorStop(1, "#D6D6D2");
      x.fillStyle = fg; x.beginPath(); x.moveTo(SW, SH - cr); x.lineTo(SW - cr, SH);
      x.quadraticCurveTo(SW - cr * 1.05, SH - cr * 0.55, SW - cr * 0.95, SH - cr * 0.95);
      x.quadraticCurveTo(SW - cr * 0.55, SH - cr * 1.05, SW, SH - cr); x.closePath(); x.fill(); x.restore();
    }
    return c;
  }

  /* ------------------------------------------------------------ Meetpunten (Microsoft Clarity) */
  function track(name, why) {
    try {
      if (typeof window.clarity !== "function") return;
      window.clarity("event", name);
      if (why) window.clarity("set", "hpdc_reden", String(why).slice(0, 120));
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ DOM */
  var ICON_UP = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>';
  // de knop staat al in de snippet; alleen aanmaken als hij ontbreekt
  if (!document.getElementById("hpdc-file")) {
    root.insertAdjacentHTML("afterbegin", '<input type="file" id="hpdc-file" class="hpdc-file" accept="image/*">');
  }
  if (!root.querySelector(".hpdc-open")) {
    root.insertAdjacentHTML("beforeend", '<label for="hpdc-file" class="hpdc-open">' + ICON_UP + '<span></span></label>');
    root.querySelector(".hpdc-open span").textContent = CFG.buttonText;
  }

  var wrap = document.createElement("div");
  wrap.innerHTML =
    // Stap 0: uploaden
    '<div class="hpdc-modal" id="hpdc-m-upload" hidden role="dialog" aria-modal="true" aria-labelledby="hpdc-up-title">' +
      '<div class="hpdc-dialog hpdc-small">' +
        '<div class="hpdc-bar"><span class="hpdc-left"><button type="button" class="hpdc-ghost" data-hpdc-close>✕ <span class="hpdc-txt">' + t("cancel") + '</span></button></span><span></span><span></span></div>' +
        '<div class="hpdc-up-head"><h2 id="hpdc-up-title">' + t("up_title") + '</h2><p>' + t("up_intro") + '</p></div>' +
        '<label class="hpdc-drop" id="hpdc-drop" for="hpdc-file" tabindex="0">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>' +
          '<strong>' + t("drop_title") + '</strong><small>' + t("drop_small") + '</small>' +
        '</label>' +
        '<p class="hpdc-error" id="hpdc-error" hidden></p>' +
        '<div class="hpdc-warn hpdc-iab" id="hpdc-iab" hidden>' + t("iab") + '</div>' +
      '</div>' +
    '</div>' +
    // Stap 1 en 2
    '<div class="hpdc-modal" id="hpdc-m-config" hidden role="dialog" aria-modal="true" aria-label="' + t("config_aria") + '">' +
      '<div class="hpdc-dialog">' +
        '<div class="hpdc-bar">' +
          '<span class="hpdc-left"><button type="button" class="hpdc-ghost" data-hpdc-close>✕ <span class="hpdc-txt">' + t("cancel") + '</span></button></span>' +
          '<div class="hpdc-steps"><span id="hpdc-st1" class="hpdc-on">' + t("step1") + '</span><span aria-hidden="true">—</span><span id="hpdc-st2">' + t("step2") + '</span></div>' +
          '<span class="hpdc-right"></span>' +
        '</div>' +
        '<div class="hpdc-body">' +
          '<div class="hpdc-side" id="hpdc-side-1">' +
            '<div class="hpdc-ok" id="hpdc-ok" role="status"></div>' +
            '<div class="hpdc-head"><h3>' + t("canvas_size") + '</h3><div class="hpdc-seg" role="group" aria-label="' + t("orientation") + '"><button type="button" id="hpdc-or-p" aria-pressed="true">' + t("portrait") + '</button><button type="button" id="hpdc-or-l" aria-pressed="false">' + t("landscape") + '</button></div></div>' +
            '<div class="hpdc-warn" id="hpdc-max-warn"></div>' +
            '<div class="hpdc-sizes" id="hpdc-sizes"></div>' +
            '<div class="hpdc-foot"><span>' + t("foot_shipping") + '</span><span>' + t("foot_checked") + '</span></div>' +
          '</div>' +
          '<div class="hpdc-side" id="hpdc-side-2" hidden>' +
            '<div class="hpdc-head"><div><b id="hpdc-sum-size"></b><div class="hpdc-hint" id="hpdc-sum-orient"></div></div><button type="button" class="hpdc-ghost" id="hpdc-edit-size" style="color:var(--hpdc-accent)">' + t("edit") + '</button></div>' +
            '<div class="hpdc-cap">' + t("finish") + '</div>' +
            '<div class="hpdc-finishes" id="hpdc-finishes"></div>' +
            '<p class="hpdc-hint" id="hpdc-finish-hint"></p>' +
            '<p class="hpdc-error" id="hpdc-save-error" hidden style="text-align:left;padding:0"></p>' +
            '<div class="hpdc-foot"><span>' + t("foot_shipping") + '</span><span>' + t("foot_checked") + '</span></div>' +
          '</div>' +
          '<div class="hpdc-main" id="hpdc-main">' +
            '<div class="hpdc-pane" id="hpdc-pane-crop">' +
              '<div class="hpdc-frame"><canvas class="hpdc-crop" id="hpdc-crop" aria-label="' + t("crop_aria") + '"></canvas></div>' +
            '</div>' +
            '<div class="hpdc-pane hpdc-pane-preview">' +
              '<div class="hpdc-frame" id="hpdc-preview-frame"><canvas id="hpdc-preview" aria-label="' + t("preview_aria") + '"></canvas><span class="hpdc-busy" id="hpdc-busy" hidden>' + t("busy") + '</span></div>' +
              '<img class="hpdc-mock" id="hpdc-mock" alt="' + t("mock_alt") + '" hidden>' +
              '<div class="hpdc-panel hpdc-fmt-panel"><span>' + t("your_size") + '</span><b id="hpdc-fmt"></b></div>' +
            '</div>' +
            '<div class="hpdc-zoompanel" id="hpdc-zoom-panel">' +
              '<div class="hpdc-zoomhead"><span class="hpdc-cap">' + t("zoom") + '</span><output id="hpdc-zoom-out">0%</output></div>' +
              '<input type="range" id="hpdc-zoom" min="1" max="3" step="0.01" value="1" aria-label="' + t("zoom") + '">' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="hpdc-actionbar">' +
          '<button type="button" class="hpdc-outline" id="hpdc-back">' + t("change_photo") + '</button>' +
          '<div class="hpdc-total"><span id="hpdc-total-label">' + t("from") + '</span><b id="hpdc-total"></b></div>' +
          '<button type="button" class="hpdc-primary hpdc-cta hpdc-next" id="hpdc-next">' + t("next") + ' <span aria-hidden="true">→</span></button>' +
        '</div>' +
        '<div class="hpdc-saving" id="hpdc-saving" hidden><h3>' + t("saving_title") + '</h3><div class="hpdc-progress"><span id="hpdc-progress"></span></div><p>' + t("saving_text") + '</p></div>' +
      '</div>' +
    '</div>' +
    // Stap 3: toegevoegd
    '<div class="hpdc-modal" id="hpdc-m-done" hidden role="dialog" aria-modal="true" aria-labelledby="hpdc-done-title">' +
      '<div class="hpdc-dialog hpdc-small">' +
        '<div class="hpdc-bar"><span></span><span></span><span class="hpdc-right"><button type="button" class="hpdc-ghost" data-hpdc-close aria-label="' + t("close") + '">✕</button></span></div>' +
        '<div class="hpdc-done">' +
          '<div class="hpdc-shot"><img id="hpdc-done-img" alt="' + t("done_alt") + '"><span class="hpdc-check"><svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span></div>' +
          '<h2 id="hpdc-done-title">' + t("done_title") + '</h2>' +
          '<p id="hpdc-done-sub"></p>' +
          '<div class="hpdc-actions"><button type="button" class="hpdc-primary hpdc-cta" id="hpdc-to-cart">' + t("to_cart") + '</button><button type="button" class="hpdc-outline" id="hpdc-again">' + t("again") + '</button></div>' +
        '</div>' +
      '</div>' +
    '</div>';
  while (wrap.firstChild) document.body.appendChild(wrap.firstChild);
  var $ = function (id) { return document.getElementById("hpdc-" + id); };

  /* ---------------------------------------------------------------- State */
  var state = {
    img: null,        // origineel (HTMLImageElement, EXIF-rotatie al toegepast)
    file: null,       // origineel bestand
    work: null,       // verkleinde kopie (max 1600 px) voor de preview
    scale: 1,         // origineel / werkkopie
    size: Math.max(0, SIZES.findIndex(function (s) { return s.key === CFG.popular; })),
    landscape: false, zoom: 1, cx: .5, cy: .5,
    frame: FRAMES[0], step: 1, dots: 0, saving: false
  };

  function dims() { var s = SIZES[state.size]; return state.landscape ? { w: s.h, h: s.w } : { w: s.w, h: s.h }; }
  function cropRect() {
    var d = dims(), a = d.w / d.h, SW = state.work.width, SH = state.work.height;
    var sw0 = Math.min(SW, SH * a), sh0 = sw0 / a, sw = sw0 / state.zoom, sh = sh0 / state.zoom;
    var x = Math.max(0, Math.min(SW - sw, state.cx * SW - sw / 2)), y = Math.max(0, Math.min(SH - sh, state.cy * SH - sh / 2));
    state.cx = (x + sw / 2) / SW; state.cy = (y + sh / 2) / SH;
    return { x: x, y: y, w: sw, h: sh };
  }
  function cropOriginal() {
    var r = cropRect(), k = state.scale, W = state.img.naturalWidth, H = state.img.naturalHeight;
    var x = Math.round(r.x * k), y = Math.round(r.y * k);
    return { x: x, y: y, w: Math.min(W - x, Math.round(r.w * k)), h: Math.min(H - y, Math.round(r.h * k)) };
  }

  /* ------------------------------------------------------------- Modals */
  /* Zwevende knoppen van andere apps (zoals de UpCart-knop rechtsonder) tijdelijk verbergen.
     Alleen elementen met position:fixed, nooit <html>, <body> of iets waar de configurator in zit. */
  var floaters = [];
  function hideFloaters(on) {
    floaters.forEach(function (f) { f.el.style.visibility = f.v; });
    floaters = [];
    if (!on) return;
    var mine = document.querySelectorAll(".hpdc-modal");
    var list;
    try { list = document.querySelectorAll('[class*="upcart" i],[id*="upcart" i],[class*="sticky" i],[id*="sticky" i]'); }
    catch (e) { list = document.querySelectorAll('[class*="upcart"],[id*="upcart"],[class*="sticky"],[id*="sticky"]'); }
    Array.prototype.forEach.call(list, function (el) {
      if (el === document.body || el === document.documentElement) return;
      if (el.closest(".hpdc-modal, .hpdc-root")) return;
      for (var i = 0; i < mine.length; i++) if (el.contains(mine[i])) return;
      if (window.getComputedStyle(el).position !== "fixed") return;
      floaters.push({ el: el, v: el.style.visibility });
      el.style.visibility = "hidden";
    });
  }

  var lastFocus = null;
  function open(id) {
    ["m-upload", "m-config", "m-done"].forEach(function (m) { $(m).hidden = m !== id; });
    document.documentElement.style.overflow = id ? "hidden" : "";
    document.documentElement.classList.toggle("hpdc-lock", !!id); // verbergt #upCartStickyButton via de CSS
    try { hideFloaters(!!id); } catch (e) {}
    if (id) { lastFocus = lastFocus || document.activeElement; var f = $(id).querySelector("button,[tabindex]"); if (f) f.focus({ preventScroll: true }); }
    else if (lastFocus) { lastFocus.focus({ preventScroll: true }); lastFocus = null; }
  }
  document.querySelectorAll("[data-hpdc-close]").forEach(function (b) { b.addEventListener("click", function () { if (!state.saving) { track("hpdc_annuleren_" + (state.step || 0)); open(null); } }); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !state.saving && !$("m-upload").hidden + !$("m-config").hidden + !$("m-done").hidden) open(null); });
  root.querySelector(".hpdc-open").addEventListener("click", function () { track("hpdc_1_knop"); });

  if (/Instagram|FBAN|FBAV|FB_IAB|TikTok|musical_ly/i.test(navigator.userAgent)) $("iab").hidden = false;

  /* -------------------------------------------------------------- Upload */
  function err(msg) { var e = $("error"); e.textContent = msg; e.hidden = false; open("m-upload"); track("hpdc_fout_foto", msg); }
  function loadFile(file) {
    $("error").hidden = true;
    if (!file) return;
    var okType = /^image\//i.test(file.type) || (!file.type && /\.(jpe?g|png|webp|heic|heif)$/i.test(file.name || ""));
    if (!okType) return err(t("err_type"));
    if (file.size > CFG.maxBytes) return err(t("err_size"));
    track("hpdc_2_foto_gekozen");
    var url = URL.createObjectURL(file), img = new Image();
    img.onload = function () {
      state.img = img; state.file = file;
      var W = img.naturalWidth, H = img.naturalHeight, sc = Math.min(1, 1600 / Math.max(W, H));
      var c = document.createElement("canvas"); c.width = Math.round(W * sc); c.height = Math.round(H * sc);
      var x = c.getContext("2d"); x.imageSmoothingQuality = "high"; x.drawImage(img, 0, 0, c.width, c.height);
      state.work = c; state.scale = W / c.width;
      state.landscape = W > H * 1.05;
      state.zoom = 1; state.cx = .5; state.cy = .5; $("zoom").value = 1; $("zoom-out").textContent = "0%";
      open("m-config"); goStep(1); refresh();
      track("hpdc_3_voorbeeld_getoond");
    };
    img.onerror = function () { URL.revokeObjectURL(url); err(t("err_open")); };
    img.src = url;
  }
  var drop = $("drop"), fi = $("file");
  drop.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fi.click(); } });
  fi.addEventListener("change", function () { if (fi.files[0]) loadFile(fi.files[0]); else track("hpdc_kiezer_geannuleerd"); fi.value = ""; });
  if (fi.files && fi.files[0]) loadFile(fi.files[0]); // foto gekozen voordat het script klaar was
  ["dragenter", "dragover"].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add("hpdc-over"); }); });
  ["dragleave", "drop"].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove("hpdc-over"); }); });
  drop.addEventListener("drop", function (e) { var f = e.dataTransfer.files[0]; if (f) loadFile(f); });

  /* ------------------------------------------------------- Stap 1: formaat */
  function buildSizes() {
    var box = $("sizes"); box.innerHTML = "";
    SIZES.forEach(function (s, i) {
      var b = document.createElement("button"), w = state.landscape ? s.h : s.w, h = state.landscape ? s.w : s.h;
      var avail = PRODUCT.variants.some(function (v) { return v["option" + sizeIdx] === s.option && v.available; });
      b.type = "button"; b.className = "hpdc-size"; b.disabled = !avail;
      b.setAttribute("aria-pressed", String(i === state.size));
      var icon = s.key === CFG.popular ? "★ " : s.key === CFG.best ? "🏆 " : "";
      var tag = s.tag ? '<span class="hpdc-tag">' + icon + s.tag + "</span>" : "";
      b.innerHTML = "<b>" + w + "x" + h + "cm</b>" + tag + '<span class="hpdc-pr">' + (avail ? t("from_price", { price: money(fromPrice(s.option)) }) : t("sold_out")) + "</span>";
      b.addEventListener("click", function () { state.size = i; refresh(); track("hpdc_formaat_" + s.key); });
      box.appendChild(b);
    });
  }
  function refresh() {
    var d = dims(), s = SIZES[state.size];
    $("main").style.setProperty("--hpdc-ar", (d.w / d.h).toFixed(4));
    $("fmt").textContent = d.w + "×" + d.h + " cm";
    $("or-p").setAttribute("aria-pressed", String(!state.landscape));
    $("or-l").setAttribute("aria-pressed", String(state.landscape));
    var adv = ADVICE[s.key];
    $("max-warn").hidden = !adv;
    if (adv) $("max-warn").innerHTML = t("max_warn", { advice: adv });
    buildSizes(); updateTotals();
    requestAnimationFrame(function () { drawCrop(); schedule(); });
  }
  $("or-p").addEventListener("click", function () { state.landscape = false; refresh(); });
  $("or-l").addEventListener("click", function () { state.landscape = true; refresh(); });
  $("zoom").addEventListener("input", function (e) { state.zoom = +e.target.value; $("zoom-out").textContent = Math.round((state.zoom - 1) * 50) + "%"; drawCrop(); schedule(); });

  function drawCrop() {
    if (!state.work || state.step !== 1) return;
    var cv = $("crop"), dpr = Math.min(window.devicePixelRatio || 1, 2), d = dims();
    var W = Math.max(1, Math.round(cv.clientWidth * dpr)), H = Math.max(1, Math.round(W * d.h / d.w));
    if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
    var ctx = cv.getContext("2d"), r = cropRect();
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(state.work, r.x, r.y, r.w, r.h, 0, 0, W, H);
    ctx.strokeStyle = "rgba(255,255,255,.55)"; ctx.lineWidth = 1; ctx.beginPath();
    for (var i = 1; i < 3; i++) { ctx.moveTo(W * i / 3, 0); ctx.lineTo(W * i / 3, H); ctx.moveTo(0, H * i / 3); ctx.lineTo(W, H * i / 3); }
    ctx.stroke();
    updateOk();
  }
  /* Geruststelling: is de foto scherp genoeg voor dit formaat? (originele pixels per cm in de uitsnede) */
  function updateOk() {
    var d = dims(), el = $("ok");
    el.innerHTML = t("photo_ok", { size: d.w + "×" + d.h + " cm" });
  }
  var timer = null;
  function schedule() { $("busy").hidden = false; clearTimeout(timer); timer = setTimeout(renderPreview, 140); }
  function renderPreview() {
    if (!state.work) return;
    var d = dims(), shown = $("preview").clientWidth * Math.min(window.devicePixelRatio || 1, 2);
    var ppc = Math.max(6, Math.min(1200 / Math.max(d.w, d.h), shown / d.w));
    state.dots = DotEngine.render(state.work, cropRect(), d.w, d.h, ppc, $("preview"));
    $("busy").hidden = true;
  }

  var crop = $("crop"), drag = null;
  crop.addEventListener("pointerdown", function (e) { drag = { x: e.clientX, y: e.clientY }; crop.setPointerCapture(e.pointerId); crop.classList.add("hpdc-dragging"); });
  crop.addEventListener("pointermove", function (e) {
    if (!drag || !state.work) return;
    var k = cropRect().w / crop.clientWidth;
    state.cx -= (e.clientX - drag.x) * k / state.work.width; state.cy -= (e.clientY - drag.y) * k / state.work.height;
    drag = { x: e.clientX, y: e.clientY }; drawCrop(); schedule();
  });
  function endDrag() { drag = null; crop.classList.remove("hpdc-dragging"); }
  crop.addEventListener("pointerup", endDrag); crop.addEventListener("pointercancel", endDrag);
  crop.addEventListener("wheel", function (e) {
    e.preventDefault();
    state.zoom = Math.max(1, Math.min(3, state.zoom * (e.deltaY < 0 ? 1.06 : 1 / 1.06)));
    $("zoom").value = state.zoom; $("zoom-out").textContent = Math.round((state.zoom - 1) * 50) + "%"; drawCrop(); schedule();
  }, { passive: false });
  var rz; window.addEventListener("resize", function () { clearTimeout(rz); rz = setTimeout(function () { drawCrop(); if (state.work && !$("m-config").hidden) renderPreview(); }, 120); });

  /* ----------------------------------------------------- Stap 2: afwerking */
  function goStep(n) {
    state.step = n;
    $("side-1").hidden = n !== 1; $("side-2").hidden = n !== 2; $("pane-crop").hidden = n !== 1; $("zoom-panel").hidden = n !== 1;
    $("main").classList.toggle("hpdc-single", n === 2);
    $("preview-frame").hidden = n === 2; $("mock").hidden = n !== 2;
    $("st1").classList.toggle("hpdc-on", n === 1); $("st2").classList.toggle("hpdc-on", n === 2);
    $("back").textContent = n === 1 ? t("change_photo") : t("back");
    $("next").innerHTML = n === 1 ? t("next") + ' <span aria-hidden="true">→</span>' : t("add_to_cart");
    $("save-error").hidden = true;
    updateTotals();
    requestAnimationFrame(function () { drawCrop(); if (state.work) renderPreview(); if (n === 2) buildFinishes(); });
  }
  function buildFinishes() {
    var d = dims(), s = SIZES[state.size];
    $("sum-size").textContent = d.w + "×" + d.h + " cm";
    $("sum-orient").textContent = (state.landscape ? t("landscape") : t("portrait")) + (ADVICE[s.key] ? t("sum_max", { advice: ADVICE[s.key] }) : "");
    var box = $("finishes"); box.innerHTML = "";
    if (FRAMES[0] === null) { box.hidden = true; return; }
    var pv = $("preview"), base = findVariant(s.option, FRAMES[0]).price;
    var thumbs = { yes: mockup(pv, true).toDataURL("image/png"), no: mockup(pv, false).toDataURL("image/png") };
    $("mock").src = isFramed(state.frame) ? thumbs.yes : thumbs.no;
    FRAMES.forEach(function (f) {
      var v = findVariant(s.option, f); if (!v) return;
      var diff = v.price - base, framed = isFramed(f), b = document.createElement("button");
      b.type = "button"; b.className = "hpdc-finish"; b.disabled = !v.available;
      b.setAttribute("aria-pressed", String(state.frame === f));
      b.innerHTML = '<span class="hpdc-thumb"><img src="' + (framed ? thumbs.yes : thumbs.no) + '" alt=""></span><b></b><span class="hpdc-sub">' + (framed ? t("framed_sub") : t("loose_sub")) + '</span><span class="hpdc-diff">' +
        (!v.available ? t("sold_out") : state.frame === f ? t("selected") : diff > 0 ? "+" + money(diff) : "") + "</span>";
      b.querySelector("b").textContent = f;
      b.addEventListener("click", function () { state.frame = f; buildFinishes(); updateTotals(); });
      box.appendChild(b);
    });
    $("finish-hint").textContent = isFramed(state.frame) ? t("framed_hint") : t("loose_hint");
  }
  function updateTotals() {
    var s = SIZES[state.size], v = findVariant(s.option, state.frame);
    $("total-label").textContent = state.step === 1 ? t("from") : t("total");
    $("total").textContent = state.step === 1 ? money(fromPrice(s.option)) : (v ? money(v.price) : "");
  }
  $("next").addEventListener("click", function () { if (state.step === 1) { track("hpdc_4_volgende"); goStep(2); } else { track("hpdc_5_in_winkelwagen_geklikt"); save(); } });
  $("back").addEventListener("click", function () { if (state.saving) return; if (state.step === 1) open("m-upload"); else goStep(1); });
  $("edit-size").addEventListener("click", function () { goStep(1); });

  /* ------------------------------------------- Opslaan en in winkelwagen */
  function toBlob(canvas, q) { return new Promise(function (res, rej) { canvas.toBlob(function (b) { b ? res(b) : rej(new Error("toBlob")); }, "image/jpeg", q); }); }

  // De exacte uitsnede uit het originele bestand, max. 16 megapixel (grens van iOS Safari)
  function exportCrop() {
    var oc = cropOriginal(), k = Math.min(1, Math.sqrt(12e6 / (oc.w * oc.h)));
    var c = document.createElement("canvas"); c.width = Math.round(oc.w * k); c.height = Math.round(oc.h * k);
    var ctx = c.getContext("2d"); ctx.imageSmoothingQuality = "high";
    ctx.drawImage(state.img, oc.x, oc.y, oc.w, oc.h, 0, 0, c.width, c.height);
    return toBlob(c, .92).then(function (b) { c.width = c.height = 1; return b; });
  }
  function exportPreview() {
    var d = dims(), c = document.createElement("canvas");
    DotEngine.render(state.work, cropRect(), d.w, d.h, 1600 / Math.max(d.w, d.h), c);
    return toBlob(c, .85);
  }
  /* Toevoegen aan de winkelwagen mét de bestanden: Shopify slaat ze zelf op en zet de link bij de bestelregel */
  function addWithFiles(fd, onProgress) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", ROUTES + "cart/add.js");
      xhr.setRequestHeader("Accept", "application/json");
      xhr.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded, e.total); };
      xhr.onload = function () {
        var json = {}; try { json = JSON.parse(xhr.responseText); } catch (e) {}
        if (xhr.status >= 200 && xhr.status < 300) resolve(json);
        else reject(new Error(json.description || json.message || "status " + xhr.status));
      };
      xhr.onerror = function () { reject(new Error(t("no_connection"))); };
      xhr.send(fd);
    });
  }
  var SHOPIFY_MAX = 20 * 1024 * 1024; // Shopify-grens per bestand
  function setSaving(on) {
    state.saving = on; $("saving").hidden = !on; $("next").disabled = on;
    if (on) $("progress").style.width = "4%";
  }

  function save() {
    if (state.saving) return;
    var s = SIZES[state.size], v = findVariant(s.option, state.frame), d = dims(), oc = cropOriginal();
    if (!v || !v.available) return;
    var ref = "HP" + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase();
    setSaving(true);
    function onP(l, t) { $("progress").style.width = Math.max(4, Math.round(l / t * 95)) + "%"; }

    // het originele bestand eerst inlezen: voorkomt lege uploads als de bron (bijv. Google Foto's) niet meer bereikbaar is
    var origBlob = CFG.uploadOriginal && state.file.size <= SHOPIFY_MAX
      ? state.file.arrayBuffer().then(function (buf) { return new Blob([buf], { type: state.file.type }); })
      : Promise.resolve(null);
    Promise.all([exportCrop(), exportPreview(), origBlob]).then(function (blobs) {
      var ext = /png/i.test(state.file.type) ? "png" : /webp/i.test(state.file.type) ? "webp" : "jpg";
      var fd = new FormData();
      fd.append("id", String(v.id));
      fd.append("quantity", "1");
      fd.append("properties[" + CFG.photoProp + "]", blobs[0], "foto-" + ref + ".jpg");
      // zichtbaar in winkelwagen, checkout en bevestigingsmail, in de taal van de klant
      fd.append("properties[" + t("prop_orientation") + "]", state.landscape ? t("landscape") : t("portrait"));
      fd.append("properties[" + t("prop_photo") + "]", t("prop_photo_value"));
      // voor de fulfilment altijd ook in het Nederlands (verborgen), zodat de orders in elke taal hetzelfde veld hebben
      if (t("prop_orientation") !== "Oriëntatie") fd.append("properties[_Oriëntatie]", state.landscape ? "Landschap" : "Portret");
      fd.append("properties[_Voorbeeld]", blobs[1], "voorbeeld-" + ref + ".jpg");
      if (blobs[2]) fd.append("properties[_Origineel]", blobs[2], "origineel-" + ref + "." + ext);
      fd.append("properties[_Uitsnede]", "x=" + oc.x + " y=" + oc.y + " b=" + oc.w + " h=" + oc.h + " (origineel " + state.img.naturalWidth + "×" + state.img.naturalHeight + " px)");
      fd.append("properties[_Canvas]", d.w + "x" + d.h + "cm, " + nl.format(state.dots) + " stippen");
      fd.append("properties[_Referentie]", ref);
      return addWithFiles(fd, onP);
    }).then(function () {
      $("progress").style.width = "100%";
      try { if (typeof window.upcartRefreshCart === "function") window.upcartRefreshCart(); } catch (e) {}
      document.dispatchEvent(new CustomEvent("hpdc:added", { detail: { variantId: v.id, ref: ref } }));
      $("done-img").src = mockup($("preview"), isFramed(state.frame)).toDataURL("image/png");
      $("done-sub").textContent = t("done_sub", { size: d.w + "×" + d.h + " cm", frame: state.frame ? " · " + state.frame : "", price: money(v.price), dots: NUM.format(state.dots) });
      setSaving(false);
      open("m-done");
      track("hpdc_6_toegevoegd");
      // UpCart tekent zijn knop na het verversen soms opnieuw: nog een keer verbergen
      setTimeout(function () { if (!$("m-done").hidden) { try { hideFloaters(true); } catch (e) {} } }, 800);
    }).catch(function (e) {
      setSaving(false);
      track("hpdc_fout_opslaan", e && e.message);
      var el = $("save-error");
      el.textContent = t("err_save", { error: e && e.message });
      el.hidden = false;
    });
  }

  $("to-cart").addEventListener("click", function () {
    open(null);
    if (typeof window.upcartOpenCart === "function") { try { window.upcartOpenCart(); return; } catch (e) {} }
    window.location.href = ROUTES + "cart";
  });
  $("again").addEventListener("click", function () { open("m-upload"); });
  window.HPDC_READY = true;
  if (window.HPDC_PENDING) { window.HPDC_PENDING = false; root.querySelector(".hpdc-open").classList.remove("hpdc-loading"); open("m-upload"); }
  if (window.console) console.log("[Happy Punch] Dot painting-configurator geladen: " + SIZES.length + " formaten, " + PRODUCT.variants.length + " varianten.");
})();